import { NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class ExportFileStatusReportCriteria extends ValueObject  
{
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public staticServiceProviderFileGroupingName: string = "";
}